module.exports = __webpack_public_path__ + "img/EZD_20240401_1.0036a404.png";